import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../shared/services/auth.service';
import { CustomDateParserFormatter } from '../../../shared/services/datepicker-adapter';
import { ProjectV2ServiceService } from '../../../shared/services/project-v2-service.service';
import { UserService } from '../../../shared/services/user.service';
@Component({
  selector: 'mtm-summary-block-criteria-1',
  templateUrl: './summary-block-criteria-1.component.html',
  styleUrl: './summary-block-criteria-1.component.scss',
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }],
  standalone: false,
})
export class SummaryBlockCriteria1Component implements OnInit, OnDestroy {
  @Input() timelineData: any;
  @Input() isDownloadComponentActive: boolean = false;
  summaryDetail: any;
  assetListCriteria: any;
  priority: string = '';
  colors = {
    CAMPAIGN: '#000000',
    PRODUCT: '#1E43A1',
    MAGELLAN: '#1E43A1',
    'COLLECTOR / PRODUCT': '#086289',
    GIFT: '#923065',
    SET: '#502B9D',
  };
  workspaceName: string;
  companyUsers: any[] = [];
  companyId: any;
  private readonly ngUnsubscribe = new Subject<void>();
  constructor(
    private readonly ProjectV2Service: ProjectV2ServiceService,
    private readonly authService: AuthService,
    private readonly userService: UserService
  ) {}

  ngOnInit(): void {
    const { companyId } = this.authService.getAuthUser();
    this.companyId = companyId;
    this.assetListCriteria = {};

    try {
      if (this.timelineData) {
        this.workspaceName = this.ProjectV2Service.workspaceName;
        this.priority = this.timelineData.priority;
        if (typeof this.timelineData.timelineCriteria == 'string') {
          const criteria = JSON.parse(this.timelineData.timelineCriteria);
          this.summaryDetail = criteria;
          if (this.timelineData.assetListCriteria) {
            this.assetListCriteria = JSON.parse(this.timelineData.assetListCriteria);
          }
        } else {
          const criteria = this.timelineData.timelineCriteria;
          this.summaryDetail = criteria;
          if (this.timelineData.assetListCriteria) {
            this.assetListCriteria = JSON.parse(this.timelineData.assetListCriteria);
          }
        }
      }
    } catch (error) {
      console.error('Error in ngOnInit:', error);
      // Reset to empty object if any error occurs
      this.assetListCriteria = {};
    }
    this.getCompanyusers();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getCompanyusers() {
    this.userService
      .getUsersByCompanyId(this.companyId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        this.companyUsers = data;
      });
  }

  getFormatedDate(timestamp: number): { year: number; month: number; day: number } {
    const date = new Date(timestamp);
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate(),
    };
  }

  getUserInfo(email: string): string {
    const user = this.companyUsers?.find((user) => user.username === email);
    return user ? user.fullName : email;
  }
}
